import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Optional, Inject } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import { datePickerMinDate, isSCCase } from '../../shared/constants';
import * as FileSaver from 'file-saver';
import { NavbarComponent } from '../../navbar/navbar.component';
declare const $: any;

@Component({
	selector: 'app-registered-candidates',
	templateUrl: './registered-candidates.component.html',
	styleUrl: './registered-candidates.component.scss'
})
export class RegisteredCandidatesComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dtOptions: Config = {};
	dataList: any = [];
	pagetitle = "Registered Candidates";
	searchVal: any = null;
	user: any = null;

	constructor(private router: Router, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	ngOnInit(): void {
		this.breadcrumbList.push({ path: "/app/registered-candidates", name: this.pagetitle });
		this.initComp();
	}

	initComp() {
		this.apiService.userData$.subscribe((user) => {
			if (user) {
				this.user = user;
				this.initDatatable();
			}
		});
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			layout: {
				topStart: ['pageLength'],
				topEnd: ['search'],
				bottomStart: ['info'],
				bottomEnd: ['paging']
			},
			ajax: (dataTablesParameters: any, callback) => {
				this.searchVal = dataTablesParameters.search.value;
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					searchVal: dataTablesParameters.search.value,
					...this.getAdvancedSearch()
				}
				this.apiService.getRegisteredCandidates(data).subscribe({
					next: (response: any) => {
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						if (error.status == 404) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	getAdvancedSearch() {
		let data: any = {};
		return data;
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}
}
